import Cookies from "js-cookie";

export const CSRF_COOKIE_NAME = "csrf_token";
export const CSRF_HEADER_NAME = "x-csrf-token";
let csrfTokenCache: string | undefined;

/**
 * Read the current CSRF token cached from the backend.
 * We intentionally cache the token from `/auth/csrf` rather than reading the
 * cookie directly because the frontend and API run on sibling subdomains in
 * local/dev (`local.societea.app` vs `api-local.societea.app`), and a host-only
 * CSRF cookie is not readable from the frontend origin.
 */
export function getCsrfToken(): string | undefined {
  return csrfTokenCache || Cookies.get(CSRF_COOKIE_NAME);
}

/**
 * Cache the latest CSRF token returned by the backend.
 */
export function setCsrfToken(token?: string | null): void {
  csrfTokenCache = typeof token === "string" && token.length > 0 ? token : undefined;
}

/**
 * Clear the in-memory CSRF token cache.
 */
export function clearCsrfToken(): void {
  csrfTokenCache = undefined;
}
